import useSuspenseQuery from 'commons/useSuspenseQuery';
import { PRODUCT_OPTIONS } from 'data-hooks/queries';
import usePDPApolloQueryVariables from 'data-hooks/usePDPApolloQueryVariables';
import isNewConsumerApp from 'commons/isNewConsumerApp';

const usePDPQueryOptionsForProductOld = ({ id, slug }, { skip } = {}) => {
  // Get variables to send to use in productOptions query. When product ID is
  // available then we only send that in the variables, otherwise we send the
  // slug. If neither slug or ID are available, then we skip the query.
  const {
    variables: productOptionsVariables,
    skip: skipProductOptionsQuery,
  } = usePDPApolloQueryVariables(id, slug);

  // Get options for this product
  const { loading, error, data } = useSuspenseQuery(PRODUCT_OPTIONS, {
    variables: productOptionsVariables,
    skip: skip || skipProductOptionsQuery,
    context: { noBatch: true },
  });

  return {
    loading: loading && !data,
    error,
    data,
    skipProductOptionsQuery,
  };
};

const usePDPQueryOptionsForProductNew = (
  { id, slug, initialProductOptions: productOptions },
  { skip } = {}
) => {
  // Build variables for the query
  const variables = id ? { id } : slug ? { slug } : {};
  // Skip query if: explicitly skipped, no variables available, or initialProductOptions provided
  const shouldSkip = skip || (!id && !slug) || !!productOptions;

  // Always call the hook (React Hooks rule)
  const { loading, error, data } = useSuspenseQuery(PRODUCT_OPTIONS, {
    variables,
    skip: shouldSkip,
    context: { noBatch: true },
  });

  // If initialProductOptions is provided, use it (SSR/pre-fetched data)
  if (productOptions) {
    return {
      loading: false,
      error: null,
      data: productOptions,
      skipProductOptionsQuery: false,
    };
  }

  return {
    loading: loading && !data,
    error,
    data,
    skipProductOptionsQuery: shouldSkip,
  };
};

// Export the appropriate version based on isNewConsumerApp
const usePDPQueryOptionsForProduct = isNewConsumerApp
  ? usePDPQueryOptionsForProductNew
  : usePDPQueryOptionsForProductOld;

export default usePDPQueryOptionsForProduct;
